/**
 * Freeze Request Status enum based on Freeze V3.3 document
 */
export enum FreezeRequestStatus {
  PENDING_REVIEW = 1,
  REQUIRE_MORE_INFO = 2,
  APPROVED_PENDING_PAYMENT = 3,
  APPROVED_PAYMENT_RECEIVED = 4,
  APPROVED_NO_PAYMENT_NEEDED = 5,
  FREEZE_APPLIED = 6,
  REJECTED = 7,
  VOID = 8,
  EXPIRED = 9,
  Approve= 10
}


/**
 * Client Document Status enum
 */
export enum CltDocStatus {
  PENDING = 1,
  VERIFIED = 2,
  REJECTED = 3
}

/**
 * Freeze Effect Mode enum
 */
export enum SubfreezeEffectMode {
  PAUSE_RECURRING = 1,
  EXTEND_TERM = 2
}

/**
 * Document Storage Provider enum
 */
export enum DocStorageProvider {
  AWS_S3 = 1,
  AZURE_BLOB = 2
}

/**
 * Freeze Mode enum for component operations
 */
export enum FreezeMode {
  REQUEST = 'request',
  FREEZE = 'freeze',
  APPROVE = 'approve'
}

/**
 * Freeze Action enum for list actions
 */
export enum FreezeAction {
  VIEW = 'view',
  APPROVE = 'approve',
  REJECT = 'reject',
  REQUIRE_MORE_INFO = 'require_more_info',
  CANCEL = 'cancel',
  ADD_COMMENT = 'add_comment'
}


export enum RecurringTemplateAdjustmentType {
  FreezeStop = 1,
  FreezeCancel = 2,
  StaffDiscount = 3,
  MidCycleAddon = 4,
  DateChange = 5,
  Coupon = 6,
  FullFreeze = 7,
  FreezeReschedule = 8,
  Adjustment = 9,
  PartialFreeze = 10
}


export enum CancelAppointmentClassBooking
{
    None = 1,
    CancelSubscriptionApptClassBooking = 2,
    CancelAll = 3
}